import cx from "classnames";
import React from "react";

import { Count, NotificationsBadge } from "@/mk2/components/NotificationsBadge";

import styles from "./ListHeadingItem.mscss";

interface OwnProps {
    /** Custom style properties */
    style?: React.CSSProperties;

    /** Add custom classname to container */
    className?: string;

    /** Custom icon for the item */
    icon?: React.ReactNode;

    /** Number displayed as counter */
    count?: Count;

    /** Start of a new section, display top border */
    isSectionStart?: boolean;

    /** Display count as badge */
    asBadge?: boolean;
}

export class ListHeadingItem extends React.Component<OwnProps> {
    public shouldComponentUpdate(n: OwnProps & { children?: React.ReactNode }) {
        const p = this.props;

        return p.isSectionStart !== n.isSectionStart || p.children !== n.children; // Only children has changed
    }

    public render() {
        const { asBadge, children, className, count, icon, isSectionStart, style } = this.props;

        const box = (
            <div className={styles.ListHeadingItem__box}>
                {icon && <div className={styles.ListHeadingItem__icon}>{icon}</div>}
                <div className={styles.ListHeadingItem__content}>{children}</div>
                {count !== undefined && (
                    <div
                        className={cx(
                            styles.ListHeadingItem__count,
                            asBadge && styles["ListHeadingItem__count--asBadge"],
                        )}
                    >
                        {asBadge ? <NotificationsBadge count={count} /> : count}
                    </div>
                )}
            </div>
        );

        return (
            <div
                className={cx(
                    styles.ListHeadingItem,
                    isSectionStart && styles["ListHeadingItem--sectionStart"],
                    className,
                )}
                style={style}
            >
                {box}
            </div>
        );
    }
}

export default ListHeadingItem;
